import React from "react";
import HCaptcha from "@hcaptcha/react-hcaptcha";
import { useDispatch } from "react-redux";
import { setHcaptchaToken } from "../../form-store/captcha-reducer";
import { ONBOARD_ALERT } from "../../form-store/action-types";

const Captcha = ({onSuccess}) => {
  const dispatch = useDispatch();

  const handleVerificationSuccess = (token, ekey) => {
    dispatch(setHcaptchaToken(token));
    onSuccess(token);
  };

  const onError = () => {
    let payload = {
      onBoardError: true,
      obBoardErrorReason: 'Error occure while validating, Please retry with the captcha.'
    }
    window.hcaptcha.reset();
    dispatch({ type: ONBOARD_ALERT, payload });
    dispatch(setHcaptchaToken(''));

  }

  const onExpire = () => {
    let payload = {
      onBoardError: true,
      obBoardErrorReason: 'Captcha expired, Please retry with the captcha.'
    }
    window.hcaptcha.reset();
    dispatch({ type: ONBOARD_ALERT, payload });

  }

  return (
    <HCaptcha
      sitekey={process.env.REACT_APP_HCAPTCHA_SITE_KEY}
      onVerify={handleVerificationSuccess}
      onError={onError}
      onExpire={onExpire}
      reCaptchaCompat={true}
    />
  );
};

export default Captcha;
